import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Canvas } from '../../components/07usenftbackupcard/canvasComponent';
import { ExplanationBackupcard } from '../../components/07usenftbackupcard/explanationBackupcardComponent';
import { HiddenSaveBackupCard } from '../../components/07usenftbackupcard/hiddenSaveBackupcardComponent';
import { Reader } from '../../components/07usenftbackupcard/readerComponent';
import { useRecoilState, useRecoilValue } from 'recoil';
import { config } from 'webpack';
import { configJsonState } from '../../states/configJsonState';

type Props = {
    // languageExchange:any,
    // closebuttonStyle: React.CSSProperties;
}

export const UseNFTBackupcardPage: React.FC<Props> = (props) => {
  const [onClickFlagStatus,setOnClickFlagStatus] = React.useState(false);//カメラのオンオフ
  const [hiddenSaveBackupCardStatus,setHiddenSaveBackupCardStatus] = React.useState(`none`);
  const [qrTagStatus,setQRTagStatus] = React.useState(<p>テストタグ</p>);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const configStatus = useRecoilValue(configJsonState);

  const UseNFTBackupcardPageComponent = styled.main`
    text-align: center;
    color: white;
    background-repeat: no-repeat;
    background-size: 100% auto;
    font-family: 'Noto Sans JP',sans-serif;

    height: 100%;
    justify-content: center;
    background-image: url(${configStatus.backgroundImage});
  `;

  return (
    <UseNFTBackupcardPageComponent>
        <ExplanationBackupcard  onClickFlagStatu={onClickFlagStatus} setOnClickFlagStatus={setOnClickFlagStatus} canvasRef={canvasRef} videoRef={videoRef} setQRTagStatus={setQRTagStatus} setHiddenSaveBackupCardStatus={setHiddenSaveBackupCardStatus}/>
        <p id="debugmes"></p>
        <HiddenSaveBackupCard qrTagStatus={qrTagStatus} hiddenSaveBackupCardStatus={hiddenSaveBackupCardStatus}/>
        <Reader videoRef={videoRef}/>
        <Canvas canvasRef={canvasRef}/>
    </UseNFTBackupcardPageComponent>
  );
};